<template>
    <tr @click="toggleSelected(item)" class="cursor-pointer">
        <td
            class="border-t border-gray-100 px-3 py-1.5 sm:px-4"
        >
            <div class="flex items-center">
                <div
                    class="2xl:w-10 2xl:w-10 h-3 w-3 flex-shrink-0 self-start sm:h-4 sm:w-4"
                >
                    <base-checkbox
                        class="mt-2.5"
                        v-model="selected"
                    />
                </div>
                <div class="ml-3">
                    <div class="text-xs font-medium leading-5 text-gray-900">
                        {{ item.name }}
                    </div>
                    <div v-if="item?.modifiers?.length > 0">
                        <div
                            v-for="(modifier, key) in item.modifiers"
                            :key="`${item.id}-${modifier.id}-${key}`"
                            class="ml-1 flex flex-row items-center text-gray-700"
                        >
                            <base-curved-arrow-icon class="h-3 w-3 rotate-180 transform-gpu mr-1" />
                            <span class="pl-1 text-xs leading-5 text-green-600 w-full">
                                {{ modifier.name }}
                            </span>
                        </div>
                    </div>
                    <div v-if="item?.notes?.length > 0" class="ml-1 mt-1 border rounded-md px-1 py-0.5 bg-gray-50 border-dashed inline-flex items-center flex-row whitespace-normal">
                        <base-warning-icon
                            class="max-h-4 max-w-4 text-yellow-700 inline-block"
                        />
                        <span class="pl-1 text-xs leading-5 text-gray-500">
                            {{ item.notes }}
                        </span>
                    </div>
                </div>
            </div>
        </td>
        <td
            class="whitespace-nowrap border-b border-gray-100 px-3 py-0.5 text-right align-top sm:px-4"
            @click.stop
        >
            <input
                v-model.number="refundQuantity"
                type="number"
                :min="1"
                :max="item.quantity"
                :disabled="item.quantity === 1"
                class="rounded border border-gray-300 px-1 py-0.5 text-center font-mono text-xs font-semibold text-gray-600 focus:border-black focus:outline-none focus:ring-1 focus:ring-black disabled:cursor-not-allowed"
                @input="validateAndUpdateQuantity"
                @blur="validateAndUpdateQuantity"
            />
            <span class="ml-1 font-mono text-xs font-semibold text-gray-600"
                >of {{ item.quantity }}</span
            >
        </td>
        <td
            class="whitespace-nowrap border-b border-gray-100 px-3 py-1.5 text-right font-mono sm:px-4 align-top"
        >
            <div class="text-xs leading-5 text-gray-900">
                {{ (countItemPrice / 100) | currency }}
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    name: 'RefundOrderMenuItem',
    props: {
        item: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            selected: false,
            price: 0,
            refundQuantity: 1
        };
    },
    mounted() {
        this.refundQuantity = this.item.quantity;
    },
    methods: {
        toggleSelected(item) {
            this.selected = !this.selected;

            let id = item.id.toString() + '-' + this.index;

            if (item?.modifiers?.length > 0) {
                id += item.modifiers.map(modifier => modifier.id).join('');
            }

            this.$emit('selected', {
                id,
                price: this.selected ? this.refundPrice : 0,
                quantity: this.selected ? this.refundQuantity : 0,
                maxQuantity: this.item.quantity
            });
        },
        updateRefundQuantity() {
            if (this.selected) {
                let id = this.item.id.toString() + '-' + this.index;

                if (this.item?.modifiers?.length > 0) {
                    id += this.item.modifiers
                        .map(modifier => modifier.id)
                        .join('');
                }

                this.$emit('selected', {
                    id,
                    price: this.refundPrice,
                    quantity: this.refundQuantity,
                    maxQuantity: this.item.quantity
                });
            }
        },
        validateAndUpdateQuantity() {
            if (this.refundQuantity < 1) {
                this.refundQuantity = 1;
            } else if (this.refundQuantity > this.item.quantity) {
                this.refundQuantity = this.item.quantity;
            }

            this.updateRefundQuantity();
        },
        getPriceWithModifiers() {
            let price = this.item.price;

            if (this.item.modifiers) {
                this.item.modifiers.forEach(modifier => {
                    price += modifier.price * (modifier.quantity ?? 1);
                });
            }

            return price;
        }
    },
    computed: {
        countItemPrice() {
            return this.getPriceWithModifiers() * this.item.quantity;
        },
        refundPrice() {
            return this.getPriceWithModifiers() * this.refundQuantity;
        }
    }
};
</script>
